import BannerAdTakeover from './types/BannerAdTakeover.js';
import BannerAdNative from './types/BannerAdNative.js';
import BannerAdNativeProductFallback from './types/BannerAdNativeProductFallback.js';
import BannerAdTopboard from './types/BannerAdTopboard.js';
import BannerAd from './types/BannerAd.js';

class BannerAdFactory {
    constructor(ctx) {
        this._appNexusData = ctx.appNexusData;
        this._allowedTakeoverTags = ctx.allowedTakeoverTags;
        this._allowedSSAProductTags = ctx.allowedSSAProductTags;
    }

    create(tagName, adObj) {
        let bannerAd;
        this._tagName = tagName;

        if (this._isTakeover(tagName, adObj)) {
            bannerAd = new BannerAdTakeover();
        } else if (this._isNative(adObj)) {
            bannerAd = new BannerAdNative();
        } else if (this._isTopboard(tagName)) {
            bannerAd = new BannerAdTopboard();
        } else {
            bannerAd = new BannerAd();
        }

        bannerAd.setup(
            this._tagName,
            adObj,
            this._appNexusData,
            this._allowedTakeoverTags,
            this._allowedSSAProductTags
        );
        return bannerAd;
    }

    createBlankFallback(tagName) {
        let bannerAd;
        this._tagName = tagName;

        if (this._isSSAProduct(tagName)) {
            bannerAd = new BannerAdNativeProductFallback();
        } else {
            bannerAd = new BannerAd();
        }

        bannerAd.setup(
            this._tagName,
            null,
            this._appNexusData,
            this._allowedTakeoverTags,
            this._allowedSSAProductTags
        );
        return bannerAd;
    }

    // *********************

    _isTakeover(tagName, adObj) {
        const isAllowedTag = this._allowedTakeoverTags.includes(tagName);
        return (
            isAllowedTag &&
            adObj.height &&
            adObj.width &&
            adObj.height === 3 &&
            adObj.width === 3
        );
    }

    _isNative(adObj) {
        return adObj && adObj.adType === 'native';
    }

    _isSSAProduct(tagName) {
        return (
            this._appNexusData.tags[tagName] &&
            this._appNexusData.tags[tagName].keywords &&
            this._appNexusData.tags[tagName].keywords['aa-sch-ssa-format'] ===
                'NATIVE_PRODUCT'
        );
    }

    _isTopboard(tagName) {
        return tagName === 'topboard';
    }
}

export default BannerAdFactory;



// WEBPACK FOOTER //
// ./services/banner2/BannerAdFactory.js